import {
  formatAddressMultiLine,
  formatAddressSingleLine,
} from '@repo/lib/address';
import type { Location } from '../graphql/query/getDelivery';

export const formatLocationAddressMulti = (address: Location['address']) =>
  formatAddressMultiLine({
    countryCode: address?.countryCode || '',
    address: {
      address1: address?.address1 || '',
      address2: address?.address2 || '',
      postalCode: address?.postalCode || '',
      city: address?.city || '',
      province: address?.provinceCode || address?.province || '',
    },
  });

export const formatLocationAddressSingle = (address: Location['address']) =>
  formatAddressSingleLine({
    countryCode: address?.countryCode || '',
    address: {
      address1: address?.address1 || '',
      address2: address?.address2 || '',
      postalCode: address?.postalCode || '',
      city: address?.city || '',
      province: address?.provinceCode || address?.province || '',
    },
  });
